import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import * as searchActions from '../Actions/searchActions';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Box from '@material-ui/core/Box';
import * as globalUIActions from '../Actions/globalUIActions';
import CheckIcon from '@material-ui/icons/Check';
import AccessTimeIcon from '@material-ui/icons/AccessTime';


class ServerSearchContainer extends Component {
	constructor(props) {
		super(props);
//		console.log("this.props.globalUI.maxorders: "+this.props.globalUI.maxorders);
		this.state= {
			desplegat: false,
			maxorders: (typeof this.props.globalUI.maxorders!=undefined)?this.props.globalUI.maxorders:1000
		}
		this.dropdownclick = this.dropdownclick.bind(this);
		this.changeMaxorders = this.changeMaxorders.bind(this);
		this.setMaxOrders = this.setMaxOrders.bind(this);
		//this.onChange = this.onChange.bind(this);
		//this.onFormSubmit = this.onFormSubmit.bind(this);
		//this.resetSearch = this.resetSearch.bind(this);
	}
	
	dropdownclick(){
		this.setState({desplegat: !this.state.desplegat});
	}
	
	changeMaxorders(e){
		let val = parseInt(e.target.value, 10);
		this.setState({maxorders: val});
	}
	
	setMaxOrders(e){
		this.props.actions.setMaxorders(this.state.maxorders);
	}

	render() {
		let serverSearchDropDown="";
		let processingIcon = (this.props.globalUI.processing>0) ? <AccessTimeIcon style={{ fontSize: "22px", cursor: "pointer" }}/> : "";
		let checkColor = (this.state.maxorders > this.props.globalUI.maxorders || this.state.maxorders < this.props.globalUI.maxorders ) ? "#F00" : "#FFF";
		
		if(this.props.user.role === "ADMIN"){
			if(!this.state.desplegat){
				serverSearchDropDown = <Grid item container direction="row" alignItems="center" justify="flex-start" spacing={0}>
											<Grid item xs={1}>
												<ArrowDropDownIcon style={{ fontSize: "22px", cursor: "pointer" }} onClick={this.dropdownclick}/>
											</Grid>
											<Grid item xs={10} container direction="column" alignItems="center" justify="flex-start" spacing={0} >
											</Grid>
											<Grid item xs={1}>
												{processingIcon}
											</Grid>
										</Grid>
											
			}else{
				serverSearchDropDown =	<Grid item container direction="row" alignItems="center" justify="flex-start" spacing={0}>
											<Grid item xs={1}>
												<ArrowDropUpIcon style={{ fontSize: "22px", cursor: "pointer" }} onClick={this.dropdownclick}/>
											</Grid>
											<Grid item xs={10} container direction="column" alignItems="center" justify="flex-start" spacing={0} >
												<Grid item xs={12}>
													<Box><input type="text" size="6" value={this.state.maxorders} onChange={this.changeMaxorders} /><CheckIcon style={{ fontSize: "22px", cursor: "pointer", color: {checkColor}}} onClick={this.setMaxOrders}/></Box>
												</Grid>
												
											</Grid>
											<Grid item xs={1}>
												{processingIcon}
											</Grid>
										</Grid>
			}
		}
	    return (
			serverSearchDropDown
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {globalUI: state.globalUI, user: state.user};
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(globalUIActions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(ServerSearchContainer);  